import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import critical from 'modules/upsell/lib/assets/upsell/critical.png'

const ModalHeader = () => {
  return (
    <Box flexDirection="column" alignItems="center" gap="s12">
      <Box paddingY="s16">
        <img src={critical} alt="critical" height={68} />
      </Box>
      <Text.Header1 weight="bold">{i18n.t('upsell.request_modal.error_title')}</Text.Header1>
      <Box paddingX="s12" alignItems="center" textAlign="center">
        <Text.Normal color="grey700">
          {i18n.t('upsell.request_modal.error.description')}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default ModalHeader
